import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";
import { useAuth } from "./AuthHook";

const WorkItemCategoriesContext = createContext();

export default function WorkItemCategoriesProvider({ children }) {
  const logger = useLogger();
  const auth = useAuth();
  const [currentWorkItemCategories, setWorkItemCategories] = useState([]);

  const updateWorkItemCategories = async (create = false) => {
    logger.debug(
      "WorkItemCategoriesProvider.updateWorkItemCategories",
      `GET field/WICategory`
    );
    const data = await auth.get(`field/WICategory`);
    if (data) {
      // data should be an array of strings
      logger.debug(
        "WorkItemCategoriesProvider.updateWorkItemCategories",
        `Retrieved data`
      );
      data.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
      if (data) {
        if (create)
          setWorkItemCategories(
            data.filter(({ name }) =>
              ["investigation", "parts", "follow up visit"].includes(
                name.toLowerCase()
              )
            )
          );
        else setWorkItemCategories(data);
      } else {
        setWorkItemCategories([]);
      }

      return data;
    }
    logger.debug(
      "WorkItemCategoriesProvider.updateWorkItemCategories",
      `Failed to retrieve data`
    );
    return [];
  };

  const getWorkItemCategories = () => currentWorkItemCategories;

  return (
    <WorkItemCategoriesContext.Provider
      value={{
        getWorkItemCategories,
        updateWorkItemCategories,
      }}
    >
      {children}
    </WorkItemCategoriesContext.Provider>
  );
}

WorkItemCategoriesProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useWorkItemCategories = () =>
  useContext(WorkItemCategoriesContext);
